import { Component } from '@angular/core';

@Component({
    selector: 'groupreporting-warning',
    templateUrl: './groupreporting-warning-message.component.html',
    styleUrls: ['./groupreporting-warning-message.component.scss'],
    standalone: false
})
export class GroupreportingWarningMessageComponent {

}
